<template>
  <tr>
    <template v-for="column in filterHeaders()">
      <td
        v-if="column.key === 'icons'"
        :key="column.key"
        qaid="shipment.grid.row.notes"
        class="b2b-grid__cell lg:table-cell"
        :class="[
          {
            'whitespace-nowrap': column.key === 'icons',
          },
          column.cssClasses,
        ]"
      >
        <div class="flex flex-nowrap">
          <grid-icon
            v-if="item.isSplitWarehouse"
            :data="{
              value: 'call_split',
            }"
          ></grid-icon>
          <grid-note
            v-show="item.lineComment"
            :row-id="item.id"
            :data="{
              value: 'insert_drive_file',
              content: item.lineComment,
              editable: notesEditable,
              cssClass: 'ml-1',
            }"
            :base-properties="baseProperties"
          >
          </grid-note>
        </div>
      </td>
      <grid-cell
        v-else
        :key="column.key"
        :cell-key="column.key"
        :label="column.label"
        :qaid="`order-detail-item-${column.key}`"
        :value="column.key !== 'lineStatus' ? item[column.key] : null"
        :classes="[
          {
            'whitespace-nowrap': column.key === 'lineStatus' || column.key === 'icons',
            'w-1': column.key !== 'itemName',
          },
          column.cssClasses,
        ]"
      >
        <tk-badge v-if="column.key === 'lineStatus'" :class="calculateBadgeClass(item[column.key])">
          {{ bp(item[column.key]) }}
        </tk-badge>
      </grid-cell>
    </template>
  </tr>
</template>

<script>
import {mapGetters} from 'vuex';
import TkBadge from '../../TkBadge';

export default {
  components: {
    TkBadge,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  inject: ['container', 'headers'],

  data() {
    return {
      notesEditable: false,
    };
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },
  methods: {
    filterHeaders() {
      let consumerFriendlyMode = this.consumerFriendlyMode;
      return this.headers.filter((header) => {
        if (consumerFriendlyMode && (header.key == 'unitPrice' || header.key == 'lineSubtotal')) {
          return false;
        } else {
          return true;
        }
      });
    },
    calculateBadgeClass(status) {
      let badgeColor;

      switch (status) {
        case 'CANCELLED':
          badgeColor = 'alert';
          break;
        case 'INVOICED':
          badgeColor = 'primary';
          break;
        case 'IN_WAREHOUSE':
          badgeColor = 'warning';
          break;
        case 'SHIPPED':
          badgeColor = 'success';
          break;
        case 'PLACED':
          badgeColor = 'secondary';
          break;
      }
      return `b2b-badge--${badgeColor}-light align-self-top mr-0`;
    },
  },
};
</script>
